import React, { createContext, useState, useEffect, useContext } from 'react';

// Create a context to store and manage the token
const TokenContext = createContext();

// Create a custom provider component to wrap the app
export const TokenProvider = ({ children }) => {
    const [accessToken, setAccessToken] = useState(null);
    const [linkHash, setLinkHash] = useState(null);

    // Load the token from localStorage or any other persistent storage
    useEffect(() => {
        const storedToken = localStorage.getItem('accessToken');
        const storedLinkHash = localStorage.getItem('linkHash');
        if (storedToken) {
            setAccessToken(storedToken);
        }
        if (storedLinkHash) {
            setLinkHash(storedLinkHash);
        }
    }, []);

    // Method to update the access token
    const setToken = (token) => {
        setAccessToken(token);
        // Store it in localStorage for persistence
        localStorage.setItem('accessToken', token);
    };
    // Method to update the link hash 
    const setLinkHashInLocal = (link) => {
        setLinkHash(link);
        // Store it in localStorage for persistence
        localStorage.setItem('linkHash', link);
    };

    // Method to clear the access token (e.g., for logout)
    const clearToken = () => {
        setAccessToken(null);
        localStorage.removeItem('accessToken');
    };

    return (
        <TokenContext.Provider value={{ accessToken, setToken, clearToken, linkHash, setLinkHashInLocal }}>
            {children}
        </TokenContext.Provider>
    );
};

// Custom hook to access the token context easily
export const useToken = () => {
    return useContext(TokenContext);
};
